import { MedallionBanner } from '@com-delta-omnichannel/aura';
import { DiamondMedallionBannerDetailsMocks } from './details/diamond-medallion-banner-details.mocks';
import { DiamondMedallionBannerStatusMocks } from './status/diamond-medallion-banner-status.mocks';

export const DiamondMedallionBannerMocks: MedallionBanner = {
  details: DiamondMedallionBannerDetailsMocks,
  status: DiamondMedallionBannerStatusMocks,
  ariaLabel: {
    skyPriority: 'clickable Sky Priority button opens in new tab',
    level: 'graphic level 0 logo million miler'
  },
  disabled: false,
  loaded: true,
  analyticsEvent: {
    name: 'edl-ready',
    value: 'skymiles overview page'
  }
};
